import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=7e96299a&scoped=true&"
import script from "./curriculum.vue?vue&type=script&lang=js&"
export * from "./curriculum.vue?vue&type=script&lang=js&"
import style0 from "./curriculum.vue?vue&type=style&index=0&id=7e96299a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e96299a",
  null
  
)

export default component.exports